import QuizStep from "@/icons/ui/quiz-step.svg";
import ReceiveTreatmentStep from "@/icons/ui/receive-treatment-step.svg";
import StartTreatmentStep from "@/icons/ui/start-treatment-step.svg";
import { StepItem } from "~/sections/HowItWorksSection";

export const data: StepItem[] = [
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1780526540/new_design/Image_s1yh3u.webp",
        icon: <QuizStep className="w-[110px] h-[110px] md:w-[136px] md:h-[136px]" />,
        title: "Quiz Intake",
        description: "You share your symptoms, history and goals."
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1777538362/new_design/Image_1_alw2kf.webp",
        icon: <ReceiveTreatmentStep className="w-[110px] h-[110px] md:w-[136px] md:h-[136px]" />,
        title: "Clinical approval for treatment delivery",
        description: "A licensed clinician evaluates and determines next steps. Once approved, prescription is delivered."
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1780526541/new_design/Image_1_dbkqhy.webp",
        icon: <StartTreatmentStep className="w-[110px] h-[110px] md:w-[136px] md:h-[136px]" />,
        title: "Start treatment and get ongoing support",
        description: "Our clinical care team is always here for you whenever you want to check in."
    },
];
